<template>
    <div class="chat-footer">
        <form class="chat-form" @submit.prevent="send">
            <div class="input-area" :class="{ focused: isFocused }">
                <textarea
                    v-model="message.content"
                    class="chat-input"
                    placeholder="Type a message…"
                    rows="1"
                    @focus="isFocused = true"
                    @blur="isFocused = false"
                    @input="autoResize"
                    @keydown.enter.exact.prevent="send"
                    ref="textarea"
                ></textarea>
            </div>
            <button type="submit" class="send-btn" :class="{ active: message.content && message.content.trim() }">
                <ion-icon name="send"></ion-icon>
            </button>
        </form>
    </div>
</template>

<script>
import {SupportModel} from "../../models/support";

export default {
    name: "supportMessage",
    data(){
        return {
            message: new SupportModel(),
            semaphore: 1,
            isFocused: false,
        }
    },
    methods: {
        resetMessage() {
            this.message = new SupportModel();
            this.message.from = this.$store.getters['user/getUser'].id;
            this.message.from_admin = true;
            this.$nextTick(() => {
                if (this.$refs.textarea) {
                    this.$refs.textarea.style.height = 'auto';
                }
            });
        },
        autoResize() {
            const el = this.$refs.textarea;
            if (!el) return;
            el.style.height = 'auto';
            el.style.height = Math.min(el.scrollHeight, 120) + 'px';
        },
        async send(){
            if (!this.message.content || !this.message.content.trim() || this.semaphore !== 1) return;
            this.semaphore = 0;
            const {message} = this;
            let response = await this.$store.dispatch('user/getUser', this.$route.params.userId);
            if (response.status) {
                response = await this.$store.dispatch('support/sendMessageFromAdmin', {
                    message,
                    toId: this.$route.params.userId
                });
                if (response.status) {
                    this.resetMessage();
                } else {
                    this.$store.dispatch('notification/display_noti', { message: response.message });
                }
            } else {
                this.$router.replace({ name: 'MetricsWallet' });
            }
            this.semaphore = 1;
        }
    },
    mounted() {
        this.resetMessage();
    }
}
</script>

<style scoped>
.chat-footer {
    position: fixed;
    bottom: 56px;
    left: 0;
    right: 0;
    background: #fff;
    border-top: 1px solid var(--color-border, #E2E8F0);
    padding: 10px 12px;
    z-index: 100;
}

.chat-form {
    display: flex;
    align-items: flex-end;
    gap: 10px;
}

.input-area {
    flex: 1 1 auto;
    background: var(--color-bg, #F8FAFC);
    border: 1.5px solid var(--color-border, #E2E8F0);
    border-radius: 22px;
    padding: 8px 16px;
    transition: border-color 0.2s, box-shadow 0.2s;
    display: flex;
    align-items: center;
}
.input-area.focused {
    border-color: var(--theme-primary-500, #10B981);
    box-shadow: 0 0 0 3px rgba(16,185,129,0.12);
}

.chat-input {
    border: none;
    background: transparent;
    outline: none;
    resize: none;
    font-size: 14px;
    color: var(--color-text, #0F172A);
    line-height: 1.5;
    width: 100%;
    max-height: 120px;
    overflow-y: auto;
    padding: 0;
    font-family: inherit;
}
.chat-input::placeholder {
    color: var(--color-muted, #94A3B8);
}

.send-btn {
    width: 42px;
    height: 42px;
    border-radius: 50%;
    border: none;
    background: var(--color-border, #E2E8F0);
    color: var(--color-muted, #94A3B8);
    font-size: 18px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    cursor: pointer;
    transition: background 0.2s, color 0.2s, transform 0.1s;
}
.send-btn.active {
    background: var(--theme-primary-500, #10B981);
    color: #fff;
    box-shadow: 0 3px 10px rgba(16,185,129,0.35);
}
.send-btn.active:active {
    transform: scale(0.92);
}
</style>
